export default __webpack_public_path__ + "static/media/conversations_blue.5de1e18c.svg";